module.exports = __webpack_public_path__ + "static/img/no-data.3338e979.png";